const CODE_PATTERN = /^[a-f0-9]{32}$/;
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// Parse #code=...&eid=... (order-independent) from the URL fragment.
// Returns null when either value is missing or fails format checks.
export const parseTicketHash = (hash = window.location.hash) => {
  if (!hash || hash === '#') {
    return null;
  }

  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const code = params.get('code')?.trim().toLowerCase();
  const eid = params.get('eid')?.trim();

  if (!code || !CODE_PATTERN.test(code)) {
    return null;
  }

  if (!eid || !UUID_PATTERN.test(eid)) {
    return null;
  }

  return { code, eid };
};

// Remove the fragment from the URL bar so the code is not stored in history.
export const scrubTicketHashFromUrl = () => {
  if (typeof window === 'undefined' || !window.location.hash) {
    return;
  }

  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}`
  );
};
